


















































import { Component, Watch, Vue } from 'vue-property-decorator';
import StoreFilters from '../components/shared/StoreFilters.vue';


@Component({
  components: {
    StoreFilters
  }
})
export default class StoreCatDetail extends Vue {
  categorySelected: boolean = false;
  mobileBannerImage: string = '';
  bannerAltTag: string = '';
  private screenSize: number = screen.width;
 @Watch('screenSize')
    private onchange(val: number, oldVal: number) {
      this.screenSize = val;
    }

  private mounted() {
    this.$nextTick(() => {
      window.addEventListener('resize', () => {
        this.screenSize = window.innerWidth;
      });
    });
  }


  private data() {
    return {
      selectedCategory: this.$route.params.category,
      selectedSubCategory: this.$route.params.subCategory,
      selectedFilter: this.$route.params.filter,
      storeCTA: [
        {
          category: 'featured',
          name: 'featured',
          title: 'Doc Danko\'s featured gear',
          description: 'Select apparel and gear made from only the highest quality fabrics and materials. Ideal for those feel good times and adventures.',
          mobileImage: require('../assets/store-items/featured-mobile-cta-1.jpg'),
          tabletImage: require('../assets/store-items/featured-tablet-cta-1.jpg'),
          desktopImage: require('../assets/store-items/featured-desktop-cta-1.jpg'),
          altTag: 'Doc Danko featured gear',
          bannerTitle: 'Doc Danko\'s featured gear',
          mobileBannerImage: require('../assets/store-items/featured-mobile-banner.jpg'),
          bannerDescription: 'Select gear and apparel made from only the highest quality fabrics and materials. Ideal for those feel good times and adventures.'
        },
        {
          category: 'apparel',
          name: 'womensApparel',
          subCategory: 'women',
          title: 'Doc Danko\'s women\'s apparel',
          mobileImage: require('../assets/store-items/featured-mobile-cta-2.jpg'),
          tabletImage: require('../assets/store-items/featured-tablet-cta-2.jpg'),
          desktopImage: require('../assets/store-items/featured-desktop-cta-2.jpg'),
          altTag: 'Doc Danko women\'s apparel',
          mobileBannerImage: require('../assets/store-items/mobile-womens-apparel-banner.jpg'),
          bannerDescription: 'Select apparel made from only the highest quality fabrics and materials. Ideal for those feel good times and adventures.',
          filters: [
              {
                filter: 'tshirts',
                title: 'T-shirts'
              },
              {
                filter: 'tanks',
                title: 'Tanks'
              },
              {
                filter: 'hoodies',
                title: 'Hoodies'
              },
              {
                filter: 'activewear',
                title: 'Activewear'
              }
            ]
          },
        {
          category: 'apparel',
          name: 'mensapparel',
          subCategory: 'men',
          title: 'Doc Danko\'s men\'s apparel',
          mobileImage: require('../assets/store-items/featured-mobile-cta-3.jpg'),
          tabletImage: require('../assets/store-items/featured-tablet-cta-3.jpg'),
          desktopImage: require('../assets/store-items/featured-desktop-cta-3.jpg'),
          altTag: 'Doc Danko men\'s apparel',
          mobileBannerImage: require('../assets/store-items/mobile-mens-apparel-banner.jpg'),
          bannerDescription: 'Select apparel made from only the highest quality fabrics and materials. Ideal for those feel good times and adventures.',
          filters: [
            {
                filter: 'tshirts',
                title: 'T-shirts'
              },
              {
                filter: 'tanks',
                title: 'Tanks'
              },
              {
                filter: 'hoodies',
                title: 'Hoodies'
              },
              {
                filter: 'activewear',
                title: 'Activewear'
              }
          ]
        },
        {
          category: 'swag',
          title: 'Doc Danko\'s swag',
          mobileImage: require('../assets/store-items/featured-mobile-cta-4.jpg'),
          tabletImage: require('../assets/store-items/featured-tablet-cta-4.jpg'),
          desktopImage: require('../assets/store-items/featured-desktop-cta-4.jpg'),
          altTag: 'Doc Danko swag',
          bannerDescription: 'Awesome gear for awesome people. Let your Dank flag fly with some signature swag!'
        }
      ],
    }
  }



  goToDetail(product) {
    this.$store.dispatch('setActiveStoreProduct', product);
    this.$router.push({name: 'product-detail', params: {category: this.$store.state.activeCategory, subCategory: product.subCategory, filter: product.filter, product: product.slug}});
  }

  setCategory(category) {
    this.$store.dispatch('updateStoreCategories', category);
    this.categorySelected = true;
  }


  created() {
    let storeCat = this.$data.storeCTA;

    if(this.$store.state.storeCategories < 1){
      this.$store.dispatch('setStoreCategories');
    }
    if(this.$data.selectedCategory) {
      let paramCat = this.$data.selectedCategory.toLowerCase();
      for(let i = 0; i < storeCat.length; i++) {
        let category = storeCat[i].category.toLowerCase();
        if (paramCat === category) {
          this.$store.dispatch('setFilterMenus', category);
        }
      }
    }
  }


}

